import { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Row, Col, notification, Button, Typography } from 'antd'
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom'
import { LoginForm, RequestNewPasswordForm, RegisterForm } from './'
import { useAuth } from '../../context/AuthProvider'
import { UPLOAD_ROUTE_PATH, WELCOME_ROUTE_PATH } from '../../App'
import { getCurrentLangISO } from '../../i18n'
import { GoogleLoginBtn } from './GoogleLoginBtn'
const { Title } = Typography

export const showError = (text, placement = 'bottomLeft') => {
  notification.error({
    message: text,
    placement,
  })
}

export const LoginOrRegister = ({}) => {
  const { t } = useTranslation()
  const [showLoginForm, setShowLoginForm] = useState(true)
  const { token, user, onLogin, onRequestNewPassword, onRegister } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const redirectUrl = decodeURIComponent(searchParams.get('redirect_url') || '')
  const registerFormRef = useRef(null)

  const scrollToRegistration = () => {
    window.scrollTo(0, registerFormRef.current.offsetTop)
  }

  useEffect(() => {
    if (token && user) {
      if (redirectUrl) {
        window.location.replace(redirectUrl)
      } else navigate(location.state?.from?.pathname || UPLOAD_ROUTE_PATH)
    }
  }, [token, user])

  const handleSendSuccess = () => {
    setShowLoginForm(true)
    notification.success({
      message: t('Login.RequestNewPassword.ok'),
      placement: 'bottomLeft',
    })
  }

  return (
    <Row gutter={{ sm: 0, xl: 90 }}>
      <Col xs={24} sm={14} xl={12}>
        <Title level={2} className="section-heading">
          {t('Login.HaveAnAccount')}
          <br />
          <strong>
            {showLoginForm ? t('Login.Login') : t('Login.RequestNewPassword')}
          </strong>
        </Title>
        <a
          onClick={scrollToRegistration}
          className="show-on-mobile small-link-text"
          title="Go to register form"
        >
          <Title level={2}>
            {t('Login.NewUser')}
            <strong>{t('Login.CreateAccount')}</strong>
          </Title>
        </a>
        <br />
        {showLoginForm ? (
          <LoginForm
            onForgotPassword={() => setShowLoginForm(false)}
            onSubmit={(values) =>
              onLogin(
                values,
                () => {},
                (error) => showError(t(error))
              )
            }
          />
        ) : (
          <RequestNewPasswordForm
            onBackToLogin={() => setShowLoginForm(true)}
            onSubmit={(values) =>
              onRequestNewPassword(values, handleSendSuccess, (error) =>
                showError(t(error))
              )
            }
          />
        )}
        <br />
        <Title level={2} className="section-heading">
          {t('Login.LowUser')}
        </Title>
        <GoogleLoginBtn />
      </Col>
      <Col xs={24} sm={14} xl={12} ref={registerFormRef}>
        <RegisterForm
          onSubmit={(values) =>
            onRegister(
              {
                language: getCurrentLangISO(),
                ...values,
              },
              () => {
                if (redirectUrl) {
                  window.location.replace(redirectUrl)
                } else navigate(WELCOME_ROUTE_PATH)
              },
              (error) => showError(t(error), 'bottomRight')
            )
          }
        />
      </Col>
    </Row>
  )
}
